module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_01-c44835df30d8b1cfb7f47697eab0c3aa.png";